import React, { useState } from "react"
import { collection, addDoc, updateDoc, doc } from "firebase/firestore"
import { IconSend } from "@tabler/icons-react"
import { useAuth } from "../../../Auth/AuthProvider"
import { db } from "../../../firebase"

const fieldClass =
  'w-full border border-mauve-200 bg-white px-3 py-2 text-mauve-900 outline-none transition focus:border-mauve-500'

export default function CreateRequest(props) {
  const [requestTitle, setRequestTitle] = useState('')
  const [requestEmail, setRequestEmail] = useState('')
  const { uid } = useAuth()

  const handleChange = ({ currentTarget: { name, value } }) => {
    if (name === "requestTitle") setRequestTitle(value)
    if (name === "requestEmail") setRequestEmail(value)
  }

  const createNewRequest = async (title, email) => {
    const requestsCollection = collection(db, "users", uid, "requests")
    const docRef = await addDoc(requestsCollection, {
      title,
      recipient: email,
      urlKey: crypto.randomUUID(),
      created_at: Date.now(),
      opened_at: null,
      replied_at: null,
      payload: null,
      status: 2,
    })
    await updateDoc(doc(db, "users", uid, "requests", docRef.id), {
      request_id: docRef.id,
    })
    setRequestTitle('')
    setRequestEmail('')
    props.setCreatingNew()
  }

  return (
    <div className="w-full border border-mauve-200 bg-white p-4">
      <form className="grid gap-3 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <small className="text-mauve-500">Request title</small>
          <input type="text" name="requestTitle" value={requestTitle} onChange={handleChange} className={fieldClass} />
        </div>
        <div>
          <small className="text-mauve-500">To</small>
          <input type="email" name="requestEmail" value={requestEmail} onChange={handleChange} className={fieldClass} />
        </div>
        <div className="hidden lg:block" />
        <div className="flex items-end gap-2">
          <button
            type="button"
            disabled={!(requestTitle && requestEmail)}
            className="bg-mauve-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-mauve-900 disabled:cursor-not-allowed disabled:bg-mauve-300"
            onClick={(e) => {
              e.preventDefault()
              createNewRequest(requestTitle, requestEmail)
            }}
          >
            <IconSend className="mr-2 inline size-4" />
            Send
          </button>
          <button
            type="button"
            className="border border-mauve-300 px-4 py-2 text-sm text-mauve-700 hover:bg-mauve-50"
            onClick={props.setCreatingNew}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}
